import { PagedCollection } from '@shared/models/pagination/paged-collection';
import { defaultPagedCollection } from '../../models/pagination/default-paged-collection.config';
import { StoreTelemonitoring } from './models/store-telemonitoring';

type PagedTelemonitoringsCollection = PagedCollection<{ [telemonitoringId: number]: StoreTelemonitoring }>;

export type TelemonitoringsState = {
  telemonitorings: PagedTelemonitoringsCollection;
  isLoaded: boolean;
};

export const initialTelemonitoringsState: TelemonitoringsState = {
  telemonitorings: {
    ...(defaultPagedCollection as PagedTelemonitoringsCollection),
  },
  isLoaded: false,
};
